export default __webpack_public_path__ + "assets/images/4.eacd17.webp";